/**
 * Bio Format Utilities
 *
 * Provides smart format detection for teacher bio content.
 * Handles both plain text (with \n line breaks) and HTML content.
 */

/**
 * Detects whether text contains HTML tags.
 *
 * @param {string} text - The text to check
 * @returns {boolean} - True if HTML tags are detected
 */
function containsHtmlTags(text) {
  if (!text) return false;
  // Check for common HTML tags: <p>, <br>, <div>, <strong>, <em>, <ul>, <li>, <a>, <span>, etc.
  return /<[a-z][\s\S]*?>/i.test(text);
}

/**
 * Converts plain text with newlines to HTML.
 *
 * - Single \n becomes <br>
 * - Double \n\n becomes paragraph break
 *
 * @param {string} text - The plain text to convert
 * @returns {string} - HTML formatted text
 */
function convertPlainTextToHtml(text) {
  if (!text) return '';

  // Check if there are double newlines (paragraphs)
  if (text.includes('\n\n')) {
    // Split by double newlines to create paragraphs
    const paragraphs = text.split(/\n\n+/);
    return paragraphs
      .map(p => {
        // Convert single newlines within paragraph to <br>
        const withBr = p.replace(/\n/g, '<br>');
        return `<p>${withBr}</p>`;
      })
      .join('');
  }

  // No paragraphs, just convert single newlines to <br>
  return text.replace(/\n/g, '<br>');
}

export { containsHtmlTags, convertPlainTextToHtml };
